import { apolloClientChat as apolloClient } from "../../vue-apollo";

import {
  CREAR_CHAT_INDIVIDUAL,
  ENVIAR_MENSAJE_CHAT_INDIVIDUAL,
  ENVIAR_MENSAJE_CHAT_GRUPO,
  INSERTAR_VISTO_INDIVIDUAL,
  INSERTAR_VISTO_GRUPAL,
  AGREGAR_FAVORITO_CHAT,
  ELIMINAR_FAVORITO_CHAT,
  ELIMINAR_CHAT_INDIVIDUAL
} from "../../graphql/mutations";

import {
  GET_LISTA_CHAT_INDIVIDUAL,
  GET_LISTA_CHAT_GRUPAL,
  GET_LISTA_CONTACTOS
} from "../../graphql/queries";

export default {
  namespaced: true,
  state: {
    listaChatIndividual: [],
    listaChatGrupal: [],
    listaContactos: []
  },
  mutations: {
    setListaChatIndividual(state, listaChats) {
      state.listaChatIndividual = listaChats;
    },
    // addNewChat(state, newChat) {
    //   state.listaChatIndividual.unshift(newChat);
    // },
    setListaChatGrupal(state, listaChats) {
      state.listaChatGrupal = listaChats;
    },

    // addNewMensajeIndividual(state, newMessage) {
    //   const chatIdx = state.listaChatIndividual.findIndex(chat => chat.id_chat === newMessage.id_chat_fk);
    //   state.listaChatIndividual[chatIdx].unshift(newMessage);
    // },
    /* TODO:... */
    // addNewMensajeGrupal(state, newMessage) {
    //   const chatIdx = state.listaChatGrupal.findIndex(chat => chat.id_grupo === newMessage.id_grupo_fk);
    //   state.listaChatIndividual[chatIdx].unshift(newMessage);
    // },
    setListaContactos(state, listaContactos) {
      // blabla cargo es un array..
      state.listaContactos = listaContactos;
    }
  },

  actions: {
    async createChat(_, payload) {
      const queryParams = {
        mutation: CREAR_CHAT_INDIVIDUAL,
        variables: payload
      };

      let response = null;
      try {
        const res = await apolloClient.mutate(queryParams);
        if (!res.loading) response = res.data.crearMensajeChatIndividual;
        // commit("addNewChat", response);

      } catch (e) {
        console.log("Falla action createChat", e);
      }

      return response;
    },

    /* no usado */
    async getChatsIndividual({ commit }, payload) {
      const queryParams = {
        query: GET_LISTA_CHAT_INDIVIDUAL,
        variables: payload
      };

      let response = null;
      try {
        const res = await apolloClient.query(queryParams);
        if (!res.loading) response = res.data.listaChatIndividual;
        commit("setListaChatIndividual", response);

      } catch (e) {
        console.log("Falla action getChatsIndividual", e);
      }

      return response;
    },

    /* no usado */
    async getChatsGrupal({ commit }, payload) {
      const params = {
        query: GET_LISTA_CHAT_GRUPAL,
        variables: payload
      };

      let response = null;
      try {
        const res = await apolloClient.query(params);
        if (!res.loading) response = res.data.listaChatGrupal;
        commit("setListaChatGrupal", response);
      } catch (e) {
        console.log("Falla action getChatsGrupal", e);
      }

      return response;
    },

    async sendMensajeIndividual(_, payload) {
      const params = {
        mutation: ENVIAR_MENSAJE_CHAT_INDIVIDUAL,
        variables: payload
      };
      let response = null;
      try {
        const res = await apolloClient.mutate(params);
        if (!res.loading) response = res.data.enviarMensajeChat;
      } catch (e) {
        console.log("Falla action sendMensajeIndividual: ", e);
      }
      return response;
    },

    async sendMensajeGrupal(_, payload) {
      const params = {
        mutation: ENVIAR_MENSAJE_CHAT_GRUPO,
        variables: payload
      };
      let response = null;
      try {
        const res = await apolloClient.mutate(params);
        if (!res.loading) response = res.data.enviarMensajeGrupo;
      } catch (e) {
        console.log("Falla action sendMensajeGrupal: ", e);
      }
      return response;
    },

    async insertVistoIndividual(_, payload) {
      const params = {
        mutation: INSERTAR_VISTO_INDIVIDUAL,
        variables: payload
      };
      let response = null;
      try {
        const res = await apolloClient.mutate(params);
        if (!res.loading) response = res.data.insertarVistoIndividual;
      } catch (e) {
        console.log("Falla action insertarVistoIndividual: ", e);
      }
      return response;
    },

    async insertVistoGrupal(_, payload) {
      const params = {
        mutation: INSERTAR_VISTO_GRUPAL,
        variables: payload
      };
      let response = null;
      try {
        const res = await apolloClient.mutate(params);
        if (!res.loading) response = res.data.insertarVistoGrupal;
      } catch (e) {
        console.log("Falla action insertarVistoGrupal: ", e);
      }
      return response;
    },


    async agregarFavorito(_, payload) {
      const params = {
        mutation: AGREGAR_FAVORITO_CHAT,
        variables: payload
      };
      let response = null;
      try {
        const res = await apolloClient.mutate(params);
        if (!res.loading) response = res.data.agregarFavorito;
      } catch (e) {
        console.log("Falla action agregarFavorito: ", e);
      }
      return response;
    },

    async eliminarFavorito(_, payload) {
      const params = {
        mutation: ELIMINAR_FAVORITO_CHAT,
        variables: payload
      };
      let response = null;
      try {
        const res = await apolloClient.mutate(params);
        if (!res.loading) response = res.data.eliminarFavorito;
      } catch (e) {
        console.log("Falla action eliminarFavorito: ", e);
      }
      return response;
    },

    async deleteChat(_, payload) {
      const params = {
        mutation: ELIMINAR_CHAT_INDIVIDUAL,
        variables: payload
      };
      let response = null;
      try {
        const res = await apolloClient.mutate(params);
        if (!res.loading) response = res.data.eliminarChat;
      } catch (e) {
        console.log("Falla action eliminarChat: ", e);
      }
      return response;
    },




    async getContactos({ commit }, payload) {
      const params = {
        query: GET_LISTA_CONTACTOS,
        variables: payload
      };

      let response = null;
      try {
        const res = await apolloClient.query(params);
        if (!res.loading) response = res.data.contactos;
        commit("setListaContactos", response);
      } catch (e) {
        console.log("Falla action getContactos", e);
      }
      return response;

    }

  }
};